import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";
import { crashGames } from "../../../../lib/data/crashGames.data";
import BackIcon from "../../../../assets/svg/BackIcon";

const CrashGames = () => {
  const { isAuth } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  // Convert object to array
  const crashGamesArray = Object.values(crashGames);

  return (
    <>
      <HeaderAfterLogin />

      <main className="main">
        <div className="container-fluid">
          <div className="pagesHeading">
            <h2 className="sectionTitle border-0">Crash Games</h2>
            <div className="back-link" onClick={() => navigate(-1)}>
              Back <BackIcon />
            </div>
          </div>

          <div className="casinoProvidersGames games-section">
            <ul className="gamelisting">
              {crashGamesArray.length > 0 ? (
                crashGamesArray.map((game, idx) => (
                  <li key={`crashgame-${idx}`}>
                    <a href={game.href}>
                      <img src={game.imgUrl} alt={game.alt} />
                      <div className="GameName">{game.name}</div>
                    </a>
                  </li>
                ))
              ) : (
                <p>No games available for this category.</p>
              )}
            </ul>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default CrashGames;
